module.exports = "/static/media/headerBg.75dd9ddd.png";